import { MINUTES_TO_MILLISECONDS } from './constants';
import { format } from 'date-fns';

export function convertTimestampToIso8601Format(timestamp: number): string {
  const timezoneOffset = new Date(timestamp).getTimezoneOffset();
  const date = new Date(timestamp + timezoneOffset * MINUTES_TO_MILLISECONDS);

  return format(date, "yyyy-MM-dd'T'HH:mm:ss+00:00");
}
